/**
 * 本地、日常、预发、线上接口域名匹配
 * @type {string}
 */
import * as forEach from 'lodash/forEach';

/*
 平台化应用域名规则：

 俄罗斯

 预发环境：appName-wms-stg.ru.cainiao.com
 线上环境：appName-wms.ru.cainiao.com

 新加坡

 预发环境：appName-wms-stg.sg.cainiao.com
 线上环境：appName-wms.sg.cainiao.com

 其它国家

 预发环境：appName-wms-stg.country.cainiao.com
 线上环境：appName-wms.country.cainiao.com

 国内

 预发环境：pre-appName-wms.cainiao.com
 线上环境：appName-wms.cainiao.com


 基础

 把appName-去掉

 比如：

 俄罗斯：wms-stg.ru.cainiao.com（预发）wms.ru.cainiao.com（线上）
 国内：pre-wms.cainiao.com（预发）wms.cainiao.com（线上）

 */

var url = window.location.href;
var wirelesshost = 'wireless.';
var orderhost = 'order.';
var basicPre = '';
var host = 'wms.cainiao.com';
var hostMap = {};
var country = '';
var iwms = {
  pro: '',
  pre: ''
};
var iqc = {
  pre: ''
};
if (url.indexOf('.sg.') > -1) {
  // 新加坡
  host = 'wms.sg.cainiao.com';
  wirelesshost = 'wireless-';
  orderhost = 'order-';
  basicPre = 'wms-stg.sg.cainiao.com';
  iwms.pro = 'iwms.sg.cainiao.com';
  iwms.pre = 'iwms-stg.sg.cainiao.com';
  iqc.pre = 'iqc-wms-stg.sg.cainiao.com';
  country = 'sg';
} else if (url.indexOf('.ru.') > -1) {
  // 俄罗斯
  host = 'wms.ru.cainiao.com';
  wirelesshost = 'wireless-';
  orderhost = 'order-';
  basicPre = 'wms-stg.ru.cainiao.com';
  iwms.pro = 'iwms.ru.cainiao.com';
  iwms.pre = 'iwms-stg.ru.cainiao.com';
  iqc.pre = 'iqc-wms-stg.ru.cainiao.com';
  country = 'ru';
} else {
  // 国内
  basicPre = "pre-" + host;
  iwms.pro = 'iwms.cainiao.com';
  iwms.pre = 'iwms-pre.cainiao.com';
  iqc.pre = 'pre-iqc.wms.cainiao.com';
  country = 'domestic';
}
var domainMap = {
  // 基础
  basic: {
    https: host,
    // 未开启
    pro: host,
    pre: basicPre,
    daily: 'wmp.daily.taobao.net'
  },
  // 鉴权
  auth: {
    https: 'auth.wms.cainiao.com',
    // 未开启
    pro: 'auth.wms.cainiao.com',
    pre: 'pre-auth.wms.cainiao.com',
    daily: 'auth.daily.taobao.net'
  },
  // 入库
  rk: {
    https: "rk-" + host,
    // 未开启
    pro: "rk." + host,
    pre: "pre-rk." + host,
    daily: 'rk-wms.daily.taobao.net'
  },
  // 库内
  kn: {
    https: "kn-" + host,
    // 未开启
    pro: "kn." + host,
    pre: "pre-kn." + host,
    daily: 'kn-wms.daily.taobao.net'
  },
  // 订单
  order: {
    https: "order-" + host,
    // 未开启
    pro: orderhost + host,
    pre: "pre-order." + host,
    daily: 'order-wms.daily.taobao.net'
  },
  // 库存
  kc: {
    https: "kc-" + host,
    // 未开启
    pro: "kc." + host,
    pre: "pre-kc." + host,
    daily: 'kc-wms.daily.taobao.net'
  },
  // 出库
  ck: {
    https: "ck-" + host,
    // 未开启
    pro: "ck." + host,
    pre: "pre-ck." + host,
    daily: 'ck-wms.daily.taobao.net'
  },
  // 无线RF
  wireless: {
    https: "wireless-" + host,
    // 未开启
    pro: wirelesshost + host,
    pre: "pre-wireless." + host,
    daily: 'wireless.wmp.daily.taobao.net'
  },
  // sym
  sym: {
    https: "sym-" + host,
    // 未开启
    pro: "sym." + host,
    pre: "pre-sym." + host,
    daily: 'sym.wmp.daily.taobao.net'
  },
  // 数据
  sj: {
    https: "sj-" + host,
    // 未开启
    pro: "sj." + host,
    pre: "pre-sj." + host,
    daily: 'sj-wms.daily.taobao.net'
  },
  // control
  control: {
    https: "control-" + host,
    // 未开启
    pro: "control." + host,
    pre: "pre-control." + host,
    daily: 'control-wms.daily.taobao.net'
  },
  // iqc
  iqc: {
    https: "iqc-" + host,
    // 未开启
    pro: "iqc-" + host,
    pre: iqc.pre,
    daily: 'iqc-wms.daily.taobao.net'
  },
  // iwms

  iwms: {
    https: iwms.pro,
    // 未开启
    pro: iwms.pro,
    pre: iwms.pre,
    daily: 'iwms.daily.taobao.net'
  },
  operate: {
    https: "operate-" + host,
    // 未开启
    pro: "operate." + host,
    pre: "pre-operate." + host,
    daily: 'operate.daily.taobao.net'
  },
  wmpshipping: {
    https: "shipping-" + host,
    pro: "shipping-" + host,
    pre: "pre-shipping." + host,
    daily: 'shipping-wms.daily.taobao.net'
  },
  supportRobotics: {
    https: 'support-robotics.cainiao.com',
    pro: 'support-robotics.cainiao.com',
    pre: 'pre-support-robotics.cainiao.com',
    daily: 'support-robotics.project.taobao.net'
  }
};

// 俄罗斯预发环境适配
if (url.indexOf('.ru.') > -1) {
  domainMap.iqc.pro = 'iqc-wms.ru.cainiao.com';
  domainMap.iqc.pre = 'iqc-wms-stg.ru.cainiao.com';
}
forEach(domainMap, function (module, key) {
  forEach(module, function (m, k) {
    hostMap[m] = {
      module: key,
      env: k
    };
  });
});

/**
 * 获取预发的域名
 * @param {*} codeParam
 */
function getPreHost(code) {
  if (country === 'domestic') {
    return "pre-" + code + "-wms.cainiao.com";
  }
  return code + "-wms-stg." + country + ".cainiao.com";
}

/**
 * 获取线上的域名
 * @param {*} code
 */
function getProHost(code) {
  if (country === 'domestic') {
    return code + "-wms.cainiao.com";
  }
  return code + "-wms." + country + ".cainiao.com";
}

/**
 * 获取host
 *
 * 例如: getHost('basic','pro')
 *      ====>
 *      basic
 *
 * @param host
 * @returns {*|string|string}
 */
function getHost(CODE, ENV) {
  var env = ENV || 'pro';
  if (typeof CODE === 'undefined') {
    return window.location.host;
  }
  if (domainMap[CODE]) {
    return domainMap[CODE][env];
  }
  // 处理其他符合标准域名情况
  var dm = {
    https: getProHost(CODE),
    pro: getProHost(CODE),
    pre: getPreHost(CODE),
    daily: CODE + "-wms.daily.taobao.net"
  };
  return dm[env];
}

/**
 * 通过匹配domainMap, 解析当前域名是什么模块
 *
 * 例如: parseModule('wms.cainiao.com')
 *      ====>
 *      basic
 *
 * @param host
 * @returns {*|string|string}
 */
function parseModule(hostParam) {
  var o = hostMap[hostParam];
  return o && o.module;
}

/**
 * 通过匹配domainMap, 解析当前域名是什么环境
 *
 * 例如: parseModule('wms.cainiao.com')
 *      ====>
 *      pro
 *
 * @param host
 * @returns {*|string|string}
 */
function parseEnv(hostParam) {
  // 环境, 默认为线上环境
  // HTTPS的线上环境也解析为HTTP环境
  var env = 'pro';
  if (hostParam.indexOf('pre') >= 0 || hostParam.indexOf('stg.') >= 0) {
    env = 'pre';
  } else if (hostParam.indexOf('taobao.net') >= 0 || hostParam.indexOf('cainiao.test') >= 0) {
    // 解决某些日常的域名没有是taobao.net没有daily的问题 by xpp
    env = 'daily';
  }
  return env;
}

/**
 * 根据url参数解析成指定环境env的对应URL地址
 *
 * 注:目前https的域名头会被解析成http
 *
 * 例一:
 *     transfer('http://wms.cainiao.com/console/portal.htm?p=1#head', 'daily');
 *     输出 == >
 *     http://wmp.daily.taobao.net/console/portal.htm?p=1#head
 *
 * 例二:
 *     transfer('http://wms.cainiao.com/console/portal.htm?p=1#head', 'pre');
 *     输出 == >
 *     http://pre-wms.cainiao.com/console/portal.htm?p=1#head
 *
 * @param url
 * @param env
 * @returns urlStr
 */
function transfer(urlParam, env) {
  if (typeof urlParam !== 'string') {
    return '';
  }
  var u = urlParam === null || urlParam === void 0 ? void 0 : urlParam.trim(); // url
  if (!u || !env) {
    return u;
  }

  // 去除 http(s) 协议头
  u = u.replace(/^http(s)?:/, '');
  var mockA = document.createElement('a');
  mockA.href = url;
  var apiHost = mockA.host;
  var module = parseModule(apiHost);

  // 没有匹配到对应的domain, 则不处理
  if (!module) {
    return url;
  }
  mockA.host = domainMap[module][env];
  return String(mockA.href);
}

/**
 * 根据当前环境拿到域名
 */
function getDomain(code) {
  var env = parseEnv(window.location.host);
  return getHost(code, env);
}
export default {
  transfer: transfer,
  parseEnv: parseEnv,
  parseModule: parseModule,
  getHost: getHost,
  getDomain: getDomain
};